/**
 * THIS FILE IS A DIRECT COPY OF https://git.hubteam.com/HubSpot/crm-index-data-lib/blob/master/crm-index-associations-lib/static/js/utils/isSupportedAssociation.ts#L18
 * IDEALLY, WE WOULD RELY ON THE HIDDEN FLAG OF ASSOCIATION DEFINITIONS.
 * HOWEVER, THAT IS NOT YET AVAILABLE IN THE ASSOCIATION DEFINITIONS API.
 * ONCE IT IS, WE CAN REMOVE THIS FILE AND USE THE HIDDEN FLAG INSTEAD.
 */

import { HUBSPOT_DEFINED } from 'automation-ui-associations/constants/AssociationCategory';
const TASK_TEMPLATE_TYPE_ID = '0-43';
const SALES_TASK_TYPE_ID = '0-113';
const PORTAL_OBJECT_SYNC_MESSAGE = '0-76';
const SALESFORCE_SYNC_ERROR = '0-21';
const ATTRIBUTION = '0-20';
const DATA_PRIVACY_REQUEST = '0-422';
const MARKETING_EVENT_ATTENDANCE = '0-147';
const PROSPECTING_AGENT_CONTACT_ASSIGNMENT = '0-165';
const CONVERSATION_SESSION = '0-51';
const DEAL_CREATE_ATTRIBUTION = '0-63';
const CONTACT_CREATE_ATTRIBUTION = '0-52';
const DATA_PRIVACY_CONSENT = '0-153';

/*************************
 * Object type blocklists
 *
 * Objects covered here should stay in sync with those in the below file
 * https://git.hubteam.com/HubSpot/customer-data-filters/blob/master/customer-data-filters-ui/static/js/utils/associatedRecordsUtils.ts
 ************************/
const OBJECT_TYPE_BLOCKLIST = new Set([TASK_TEMPLATE_TYPE_ID, SALES_TASK_TYPE_ID, PORTAL_OBJECT_SYNC_MESSAGE, SALESFORCE_SYNC_ERROR, ATTRIBUTION, DATA_PRIVACY_REQUEST, MARKETING_EVENT_ATTENDANCE, PROSPECTING_AGENT_CONTACT_ASSIGNMENT, CONVERSATION_SESSION, DEAL_CREATE_ATTRIBUTION, CONTACT_CREATE_ATTRIBUTION, DATA_PRIVACY_CONSENT]);
const associationDefinitionToId = associationDefinition => {
  const metaType = associationDefinition.category === HUBSPOT_DEFINED ? '0' : '1';
  return `${metaType}-${associationDefinition.id}`;
};
const isObjectTypeSupported = objectTypeId => {
  return objectTypeId && !OBJECT_TYPE_BLOCKLIST.has(objectTypeId);
};
const isFromSupported = associationDefinition => {
  return isObjectTypeSupported(associationDefinition.fromObjectTypeId);
};
const isToSupported = associationDefinition => {
  return isObjectTypeSupported(associationDefinition.toObjectTypeId);
};

/*************************
 * Specific association between two objects blocklists
 *
 * Associations covered here should stay in sync with those in the below file
 * https://git.hubteam.com/HubSpot/customer-data-filters/blob/master/customer-data-filters-ui/static/js/utils/associatedRecordsUtils.ts
 ************************/
const CONTACT_TO_CONVERSATION_ASSOCIATION_TYPE_ID = '0-62';
const TICKET_TO_CONVERSATION_ASSOCIATION_TYPE_ID = '0-32';
const DEAL_TO_CONVERSATION_ASSOCIATION_TYPE_ID = '0-58';
const DEAL_TO_PRODUCT_ASSOCIATION_TYPE_ID = '0-630';
const COMPANY_TO_CONVERSATION_ASSOCIATION_TYPE_ID = '0-60';
const PAYMENT_TO_DISCOUNT_ASSOCIATION_TYPE_ID = '0-428';
const LEAD_TO_CONTACT_ASSOCIATION_TYPE_ID = '0-608';
const LEAD_TO_COMPANY_ASSOCIATION_TYPE_ID = '0-610';
const CONVERSATION_TO_CONTACT_ASSOCIATION_TYPE_ID = '0-61';
const CONVERSATION_TO_COMPANY_ASSOCIATION_TYPE_ID = '0-59';
const CONVERSATION_TO_DEAL_ASSOCIATION_TYPE_ID = '0-57';
const CONVERSATION_TO_TICKET_ASSOCIATION_TYPE_ID = '0-31';
const LEAD_TO_ENGAGEMENT_ASSOCIATION_TYPE_ID = '0-858';
const LEAD_TO_CALL_ASSOCIATION_TYPE_ID = '0-596';
const LEAD_TO_EMAIL_ASSOCIATION_TYPE_ID = '0-598';
const LEAD_TO_MEETING_EVENT_ASSOCIATION_TYPE_ID = '0-600';
const LEAD_TO_COMMUNICATION_ASSOCIATION_TYPE_ID = '0-602';
const ASSOCIATION_ID_BLOCKLIST = new Set([CONTACT_TO_CONVERSATION_ASSOCIATION_TYPE_ID, TICKET_TO_CONVERSATION_ASSOCIATION_TYPE_ID, DEAL_TO_CONVERSATION_ASSOCIATION_TYPE_ID, DEAL_TO_PRODUCT_ASSOCIATION_TYPE_ID, COMPANY_TO_CONVERSATION_ASSOCIATION_TYPE_ID, PAYMENT_TO_DISCOUNT_ASSOCIATION_TYPE_ID, CONVERSATION_TO_CONTACT_ASSOCIATION_TYPE_ID, CONVERSATION_TO_COMPANY_ASSOCIATION_TYPE_ID, CONVERSATION_TO_DEAL_ASSOCIATION_TYPE_ID, CONVERSATION_TO_TICKET_ASSOCIATION_TYPE_ID, LEAD_TO_CONTACT_ASSOCIATION_TYPE_ID, LEAD_TO_COMPANY_ASSOCIATION_TYPE_ID, LEAD_TO_ENGAGEMENT_ASSOCIATION_TYPE_ID, LEAD_TO_CALL_ASSOCIATION_TYPE_ID, LEAD_TO_EMAIL_ASSOCIATION_TYPE_ID, LEAD_TO_MEETING_EVENT_ASSOCIATION_TYPE_ID, LEAD_TO_COMMUNICATION_ASSOCIATION_TYPE_ID]);
const isSpecificAssociationBlocklisted = associationDefinition => {
  const associationTypeId = associationDefinitionToId(associationDefinition);
  return ASSOCIATION_ID_BLOCKLIST.has(associationTypeId);
};
export const isSupportedAssociation = (associationDefinition, ___) => {
  // NOTE: If in the future we need to gate a change here, it might look something like this
  // if (
  //   typeof args === 'object' &&
  //   args.hasGate('MyGate')
  // ) {...}

  return !isSpecificAssociationBlocklisted(associationDefinition) && isFromSupported(associationDefinition) && isToSupported(associationDefinition);
};